import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const title = css`
  @media (min-width: ${dimensions.tablet}) {
    margin-bottom: 1rem;
    text-align: center;
  }
`;

export const subTitle = (theme: Theme) => css`
  color: ${theme.text.body};
`;

export const form = css`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (min-width: ${dimensions.tablet}) {
    gap: 1rem;
  }
`;
